import {CustomText, H3Text, H5Text} from '../../../../components/core/text';
import {Dimensions, StyleSheet} from 'react-native';
import React, {useCallback} from 'react';
import {
  useColorThemeType,
  useFontTheme,
} from '../../../../appStyles/hooks/theme';

import {AdjOOSData} from '@buncha/itemDetails/types/itemDetails';
import {BottomButton} from '@buncha/components/composites/Button';
import BottomSheet from '@buncha/components/composites/bottomSheet';
import {Box} from '@buncha/components/core/view';
import {CommonScreens} from '@buncha/common/navigation/types';
import {MainScreens} from '@buncha/navigation/types';
import {Modules} from '@buncha/utils/types';
import ReplacementModalBody from '../../itemReplacement/replacementModalBody';
import {ShopperScreens} from '@buncha/home/navigation/types';
import {UserTypes} from '@buncha/onBoarding/types';
import {getWidth} from '@buncha/utils/common';
import listener from '../../../../config/listener';
import {navigation} from '@buncha/config/navigation';
import {useGetLocale} from '@buncha/localization/hooks';

interface ModalBodyProps {
  onClose: any;
  open: boolean;
  runId: number;
  hasListnerReq?: boolean;
  closeOnlyModal: () => void;
  adjacentOOSData: AdjOOSData | undefined;
}

const width = Number(getWidth(Dimensions.get('screen').width));

const DropItemOOS = (props: ModalBodyProps) => {
  const theme = useColorThemeType('main');
  const mortise = useFontTheme('mortise');
  const {runId, adjacentOOSData} = props;
  const hideRole = UserTypes.driver;
  const {body, button} =
    useGetLocale(Modules.batchDetails, ShopperScreens.BatchDetailsPage) ?? {};

  const dropItemAndMarkReason = useCallback(() => {
    props?.closeOnlyModal();
    setTimeout(() => {
      navigation.navigate(MainScreens.Common, {
        screen: CommonScreens.Chat,
        params: {
          hideRole,
          conversationId: adjacentOOSData?.conversationId,
          phoneNumber: adjacentOOSData?.newShopper?.phoneNumber,
          runId: runId,
        },
      });
    }, 500);
    if (props?.hasListnerReq) listener.emit('orderPackDropRefresh');
  }, [
    adjacentOOSData?.conversationId,
    adjacentOOSData?.newShopper?.phoneNumber,
    hideRole,
    props,
    runId,
  ]);

  return (
    <BottomSheet
      open={props.open && Boolean(adjacentOOSData)}
      onClose={props.onClose}>
      <Box style={styles.mainContainer}>
        <H3Text
          style={[
            styles.textAlignLeft,
            {
              fontFamily: mortise[700]?.normal,
              color: theme?.text?.blue?.[300],
            },
          ]}>
          {body?.itemUnavailable}
        </H3Text>
        <H5Text style={[styles.textAlignLeft]}>{body?.shareThisItem}</H5Text>
        <CustomText style={[styles.textAlignLeft, styles.noteText]}>
          {body?.AOOSNote}
        </CustomText>
        <ReplacementModalBody
          text={''}
          item={adjacentOOSData?.originalCatalogItem}
          catalogItem={adjacentOOSData?.newCatalogItem}
        />
        <BottomButton
          bgColor={theme?.background?.orange?.[100]}
          style={[{width: width * 0.95}]}
          title={button?.messageAltShopper}
          onPress={dropItemAndMarkReason}
        />
      </Box>
    </BottomSheet>
  );
};

export default React.memo(DropItemOOS);

const styles = StyleSheet.create({
  textAlignLeft: {
    textAlign: 'left',
  },
  mainContainer: {
    paddingVertical: 10,
    paddingHorizontal: 15,
    width: '100%',
  },
  noteText: {
    marginTop: 20,
  },
});
